/**
 * Auflösungsstufen für Grafiken ("Mipmap"-Pyramide).
 *
 * Diese Datei ist die einzige Wahrheit für beide Seiten: der Server erzeugt beim
 * Upload genau diese Stufen, der Client wählt zur Laufzeit daraus aus. Wer hier
 * eine Stufe ergänzt, ändert automatisch beides.
 */
export const LOD_SPECS = [
    { level: 'thumb', maxEdge: 320, quality: 70 },
    { level: 'md', maxEdge: 1024, quality: 80 },
    { level: 'lg', maxEdge: 2048, quality: 85 },
    { level: 'xl', maxEdge: 4096, quality: 88 },
];
/**
 * Zuschlag auf die rechnerisch benötigte Breite, bevor die nächsthöhere Stufe
 * gezogen wird. Ohne diese Hysterese flackert die Auswahl, wenn der Nutzer genau
 * an einer Stufengrenze hin- und herzoomt.
 */
export const LOD_HEADROOM = 1.15;
/**
 * Kleinste Stufe, die für die gewünschte Anzeigebreite noch scharf ist.
 *
 * @param displayWidthPx Tatsächliche Breite auf dem Bildschirm, bereits mit
 *   Zoomfaktor und devicePixelRatio multipliziert.
 * @param variants Für dieses Bild real erzeugte Stufen (kleine Bilder haben
 *   weniger als fünf).
 */
export function pickLodLevel(displayWidthPx, variants) {
    const needed = displayWidthPx * LOD_HEADROOM;
    const sorted = [...variants].sort((a, b) => a.width - b.width);
    for (const variant of sorted) {
        if (variant.width >= needed)
            return variant.level;
    }
    // Nichts reicht aus: das verlustfreie Original muss her.
    return 'orig';
}
/** Rangfolge, um ein bereits geladenes Bild nie gegen ein schlechteres zu tauschen. */
export const LOD_RANK = {
    thumb: 0,
    md: 1,
    lg: 2,
    xl: 3,
    orig: 4,
};
//# sourceMappingURL=lod.js.map